module.exports = __webpack_public_path__ + "static/media/EHMadsen_portrait_web.725292c5.jpg";